module.exports = __webpack_public_path__ + "img/uab.41e076ac.webp";